import React, { useEffect, useLayoutEffect, useState } from 'react';
import "../Css/MenProduct.css";
import { HiMenuAlt1 } from "react-icons/hi";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { Link, useParams, useSearchParams } from 'react-router-dom';
import Footer from "../Component/FooterComponent/Footer";
import axios from 'axios';
import { Checkbox, Drawer, Collapse } from 'antd';
import { useCartContext } from '../context/addToCart';
import { PRODUCT_API_BASE_URL } from '../services/apiConfig';
import Logo from "../Images/Logo/New Footer Logo.png";
import { useCurrency } from '../services/locationService';

const { Panel } = Collapse;
const IMAGE_BASE_URL = 'https://1fiveglobal.in/uploads/productsImages/';

const MenProduct = () => {
    const { format } = useCurrency();
    const { product_category } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [loading, setLoading] = useState(false);
    const [menproduct, setMenProduct] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [showSortDropdown, setShowSortDropdown] = useState(false);

    // Read current state directly from URL Query Parameters
    const genderSelection = searchParams.get('gender') || 'all';
    const availabilitySelection = searchParams.get('availability') || 'all';
    const sortBy = searchParams.get('sort') || 'price-low';
    const subcategorySlugSelection = searchParams.get('subcategory') || 'all';

    const {
        setSelectedSize,
        setSelectedColor,
        setSelectedPrice,
        setSelectedImages,
        setSelectedProduct,
    } = useCartContext();

    // Helper function to update single/multiple query params in URL
    const updateQueryParams = (newParams) => {
        const updatedParams = new URLSearchParams(searchParams);
        
        Object.entries(newParams).forEach(([key, value]) => {
            if (value && value !== 'all') {
                updatedParams.set(key, value);
            } else {
                updatedParams.delete(key);
            }
        });

        setSearchParams(updatedParams);
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const endpoint = product_category ? product_category : 'fragrance';

            // Pass query parameters directly to backend API
            const params = {
                gender: genderSelection,
                availability: availabilitySelection,
                sort: sortBy,
                subcategory: subcategorySlugSelection
            };

            const response = await axios.get(`${PRODUCT_API_BASE_URL}products/cat/${endpoint}`, { params });

            if (response.data && response.data.success) {
                console.log("filter data con",response.data.data)
                fetchSubCategory(response?.data?.categoryId);
                setMenProduct(response.data.data || []);
            } else {
                setMenProduct([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setMenProduct([]);
        } finally {
            setTimeout(() => setLoading(false), 300);
        }
    };

    const fetchSubCategory = async (categoryId) => {
        if (!categoryId) return;
        try {
            const response = await axios.get(`${PRODUCT_API_BASE_URL}subcategories`, {
                params: { categoryId },
            });
            const subcats = response.data?.data || response.data || [];
            setSubCategoryData(subcats);
        } catch (error) {
            console.error('Error fetching subcategories:', error);
            setSubCategoryData([]);
        }
    };

    // Re-fetch API data whenever product_category or URL Search Parameters change
    useEffect(() => {
        fetchData();
    }, [product_category, searchParams]);

    const showDrawer = () => setOpenDrawer(true);
    const onCloseDrawer = () => setOpenDrawer(false);
    const toggleSortDropdown = () => setShowSortDropdown((prev) => !prev);

    return (
        <>
            <section className='men-product-banner-section'>
                <div className='men-product-banner-con'></div>
            </section>

            {/* Filter & Sort Bar */}
            <section className='men-section-filter-con'>
                <div className='men-section-filert'>
                    {/* Left Side: Filter Trigger and Gender Sub-buttons */}
                    <div className='men-section-left-filter-group'>
                        <div className='men-section-main-filert'>
                            <div className='men-section-main-filert-details' onClick={showDrawer}>
                                <h2>Filter</h2>
                                <HiMenuAlt1 />
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Sort By Dropdown */}
                    <div className='men-section-main-sort-by'>
                        <div className='men-section-main-filert-details2' onClick={toggleSortDropdown}>
                            <h2>
                                {sortBy === 'price-high' ? 'Price, high to low' : 'Price, low to high'}
                            </h2>
                            <MdOutlineKeyboardArrowDown />
                        </div>
                        <div className={`men-section-main-sort-by-dropdown ${showSortDropdown ? 'open' : ''}`}>
                            <button 
                                type="button" 
                                onClick={() => {
                                    updateQueryParams({ sort: 'price-low' });
                                    setShowSortDropdown(false);
                                }}
                            >
                                Price, low to high
                            </button>
                            <button 
                                type="button" 
                                onClick={() => {
                                    updateQueryParams({ sort: 'price-high' });
                                    setShowSortDropdown(false);
                                }}
                            >
                                Price, high to low
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className='men-section-filter-gender-con'>
                  {/* Gender Toggle Buttons directly below the Filter button */}
                        <div className='men-gender-tabs-con'>
                            {/* <button
                                type="button"
                                className={`gender-tab-btn ${genderSelection === 'all' ? 'active' : ''}`}
                                onClick={() => updateQueryParams({ gender: 'all' })}
                            >
                                All
                            </button> */}
                              <button
                                type="button"
                                className={`gender-tab-btn ${genderSelection === 'female' ? 'active' : ''}`}
                                onClick={() => updateQueryParams({ gender: 'female' })}
                            >
                                Women
                            </button>
                            <button
                                type="button"
                                className={`gender-tab-btn ${genderSelection === 'male' ? 'active' : ''}`}
                                onClick={() => updateQueryParams({ gender: 'male' })}
                            >
                                Men
                            </button>
                        </div>
            </section>

            {/* Product Grid Section */}
            <section className='men-section-3-product-list-con'>
                <div className='row product-list-row'>
                    {loading ? (
                        <div className="luxury-loader-wrapper col-12">
                            <div className="luxury-logo-box">
                                <img src={Logo} alt="Loading..." className="luxury-logo-anim" />
                                <div className="luxury-pulse-ring"></div>
                            </div>
                            <p className="luxury-loader-text">Loading Collection...</p>
                        </div>
                    ) : menproduct.length > 0 ? (
                        menproduct.map((product) => {
                            const primaryImage = product?.images?.[0]?.image
                                ? `${IMAGE_BASE_URL}${product.images[0].image}`
                                : 'https://via.placeholder.com/300x400?text=No+Image';

                            const secondaryImage = product?.images?.[1]?.image
                                ? `${IMAGE_BASE_URL}${product.images[1].image}`
                                : primaryImage;

                            return (
                                <div key={product.id || product._id} className='col-lg-3 col-md-4 col-sm-6 col-12 product-list-col'>
                                    <div className="product-card-main-con">
                                        <Link to={`/${product?.category_slug}/${product?.subcategory_slug}/${product?.slug}`}>
                                            <div className="product-card-body-con">
                                                <div className="product-card-Image-con product-item__image double__image">
                                                    <div className="product-card-Image-con product-item__image double__image new-product-item__bg">
                                                        <div className="product-item__bg">
                                                            <img src={primaryImage} alt={product?.name || 'Product'} />
                                                        </div>
                                                        <div className="product-item__bg__under">
                                                            <img src={secondaryImage} alt={product?.name || 'Product Hover'} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="Product-card-details-con">
                                                    <div className="Product-card-details">
                                                        <div className="product-card-product-name">
                                                            <h4>{product?.name || ''}</h4>
                                                        </div>
                                                        {/* {displayPrice && (
                                                            <div className="Product-card-product-review-price">
                                                                <h6>{format(displayPrice)}</h6>
                                                            </div>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="col-12 text-center py-5">
                            <h4>No products found.</h4>
                        </div>
                    )}
                </div>
            </section>

            {/* Filter Drawer */}
            <div className='Drawer-main-con'>
                <Drawer title={`${menproduct.length} ITEMS`} placement="left" onClose={onCloseDrawer} open={openDrawer}>
                    <Collapse defaultActiveKey={['1', '2']} expandIconPosition="right">
                        {/* Subcategory Filter (By Slug) */}
                        <Panel header="Subcategory" key="1">
                            <div className='Drawer-Availability-details-con'>
                                <div className='Drawer-Availability-check-box'>
                                    <Checkbox
                                        checked={subcategorySlugSelection === 'all'}
                                        onChange={() => updateQueryParams({ subcategory: 'all' })}
                                    >
                                        All
                                    </Checkbox>
                                </div>
                                {subCategoryData &&
                                    subCategoryData.map((elem) => {
                                        const slugVal = elem.slug || elem.subcategory_slug;
                                        return (
                                            <div className='Drawer-Availability-check-box' key={elem.id || elem._id || slugVal}>
                                                <Checkbox
                                                    checked={subcategorySlugSelection === slugVal}
                                                    onChange={() => updateQueryParams({ subcategory: slugVal })}
                                                >
                                                    {elem.name || elem.subcategory_name || ''}
                                                </Checkbox>
                                            </div>
                                        );
                                    })}
                            </div>
                        </Panel>

                        {/* Availability Filter */}
                        <Panel header="Availability" key="2">
                            <div className="Drawer-Availability-details-con">
                                <div className="Drawer-Availability-check-box">
                                    <Checkbox
                                        checked={availabilitySelection === 'all'}
                                        onChange={() => updateQueryParams({ availability: 'all' })}
                                    >
                                        All
                                    </Checkbox>
                                </div>
                                <div className="Drawer-Availability-check-box">
                                    <Checkbox
                                        checked={availabilitySelection === 'in-stock'}
                                        onChange={() => updateQueryParams({ availability: 'in-stock' })}
                                    >
                                        In stock
                                    </Checkbox>
                                </div>
                                <div className="Drawer-Availability-check-box">
                                    <Checkbox
                                        checked={availabilitySelection === 'out-of-stock'}
                                        onChange={() => updateQueryParams({ availability: 'out-of-stock' })}
                                    >
                                        Out of stock
                                    </Checkbox>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </Drawer>
            </div>

            <Footer />
        </>
    );
};

export default MenProduct;